var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#home_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.72 10.136 9.545 4.031l-7.174 6.106a.998.998 0 1 1-1.294-1.521L8.898 1.96a.997.997 0 0 1 1.294 0l7.822 6.656a.998.998 0 1 1-1.294 1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.546 5.272c-.201.17-6.444 5.491-6.655 5.65v7.094c0 .697.565 1.263 1.263 1.263H7.34v-5.196c0-1.462 1.397-2.5 2.783-2.124.986.268 1.627 1.227 1.627 2.249v5.07h3.192c.697 0 1.261-.564 1.261-1.26v-7.093c-.21-.159-6.457-5.482-6.658-5.653Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "home_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h18.136v21H0z"
  })))));
};
export default SvgHome;